import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { orderDB } from "../../../shared/tables/order-list";
import { OrderService } from 'src/app/shared/service/order.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-orders-item',
  templateUrl: './ordersitem.component.html',
  styleUrls: ['./ordersitem.component.scss']
})
export class OrdersitemComponent implements OnInit {
  public orderItem = [];
  public temp = [];
  public orderId:number;

  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;
  constructor(public orderService: OrderService,private route: ActivatedRoute) {
    debugger
    this.orderId = +this.route.snapshot.paramMap.get('orderId')!;
    console.log("orderitem", this.orderId);

    this.orderService.getOrdersItem(this.orderId).subscribe(data=>
      {
        console.log("all order item:", data);
        this.orderItem=data.result;
      }
    );
  }

  updateFilter(event) {

  }

  ngOnInit() {
  }

}
